import { useRef, useState } from 'react';
import GameGuide from './GameGuide';
import CoreboundNavButton from './CoreboundNavButton';

const InfoButton = ({ onOpen, relics = [] }) => {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);
  return (
    <>
      <CoreboundNavButton
        ref={buttonRef}
        type="button"
        className="coreboundInfoButton"
        aria-label="Open Corebound game guide"
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => {
          onOpen?.();
          setOpen(true);
        }}
      >
        Info
      </CoreboundNavButton>
      {open && (
        <GameGuide
          initialTopic="basics"
          relics={relics}
          onClose={() => setOpen(false)}
          returnFocusRef={buttonRef}
        />
      )}
    </>
  );
};

export default InfoButton;
